import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import LoopingItems from '../LoopingItems/LoopingItems';
import { getFieldArrayContainerConditionsInfo } from '../../utils/condition/selectors';

var FieldArrayContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(FieldArrayContainer, _Component);

  function FieldArrayContainer() {
    _classCallCheck(this, FieldArrayContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(FieldArrayContainer).apply(this, arguments));
  }

  _createClass(FieldArrayContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          loopingGroup = _this$props.loopingGroup,
          allFieldsHaveCondition = _this$props.allFieldsHaveCondition,
          someFieldConditionsFulfilled = _this$props.someFieldConditionsFulfilled,
          handleChange = _this$props.handleChange,
          uploadingFiles = _this$props.uploadingFiles,
          files = _this$props.files,
          fields = _this$props.fields,
          country = _this$props.country,
          language = _this$props.language;

      if (allFieldsHaveCondition && !someFieldConditionsFulfilled) {
        return null;
      }

      return React.createElement(FieldArray, {
        allFormFields: fields,
        name: loopingGroup.id,
        component: LoopingItems,
        loopingGroup: loopingGroup,
        handleChange: handleChange,
        uploadingFiles: uploadingFiles,
        files: files,
        country: country,
        language: language
      });
    }
  }]);

  return FieldArrayContainer;
}(Component);

var mapStateToProps = function mapStateToProps(state, props) {
  var loopingGroup = props.loopingGroup,
      fields = props.fields;
  return getFieldArrayContainerConditionsInfo(state, {
    loopingGroup: loopingGroup,
    fields: fields
  });
};

FieldArrayContainer.propTypes = {
  loopingGroup: PropTypes.object.isRequired,
  conditions: PropTypes.array,
  country: PropTypes.string,
  language: PropTypes.string
};
export default connect(mapStateToProps)(FieldArrayContainer);